exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Crumbs[data-v-4ca15009]{background-color:#000;color:#fff}#video_h5[data-v-4ca15009]{background-color:#000}.vux-tab-item[data-v-4ca15009]{color:#fff!important;background-color:#333!important}.vux-tab-selected[data-v-4ca15009]{background-color:#00b3c1!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ca15009","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Class/Course/CourseClass.vue
// module id = MiS4
// module chunks = 1